import { memo, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { StatusScreen } from 'shared/components';
import { TenantContext } from 'shared/contexts';

function OffersError() {
    const { t } = useTranslation('candidateOffers');
    const { tenant } = useContext(TenantContext);

    const description = t('errorPage.general.description', {
        tenantName: tenant?.tenantName || 'Globus'
    });

    const handleReloadClick = useCallback(() => {
        window.location.reload();
    }, []);

    return (
        <StatusScreen variant="error"
            title={ t('errorPage.general.title') }
            description={ description }
            buttonProps={{
                label: t('errorActions.refresh'),
                onClick: handleReloadClick,
                color: 'primary',
                size: 'medium'
            }}
        />
    );
}

export default memo(OffersError);
